// eslint-disable-next-line boundaries/external
import type { AbstractControl } from '@angular/forms';

/**
 *
 * @param control
 * @returns
 */
export const isNotWhitespace = (control: AbstractControl<string>) => {
    return (control.value || '').trim().length ? null : { whitespace: true };
};

/**
 *  Validate a field length to be greater than minLength, leading and trailing white spaces are ignored.
 * @param minLength The minimum length of the field.
 * @returns Validation error object if the field length is less than minLength, otherwise null.
 */
export const validateMinLengthNoWhiteSpace = (minLength: number) => {
    return (control: AbstractControl<string>) => {
        if ((control.value || '').trim().length < minLength) {
            return { minlength: true };
        }
        return null;
    };
};

/**
 * Validate a field length to be less than maxLength, leading and trailing white spaces are ignored.
 * @param maxLength
 * @returns
 */
export const validateMaxLengthNoWhiteSpace = (maxLength: number) => {
    return (control: AbstractControl<string>) => {
        if ((control.value || '').trim().length > maxLength) {
            return { minlength: true };
        }
        return null;
    };
};

export const isLettersOnly = (control: AbstractControl<string>) => {
    return RegExp("^[a-zA-Z '-]+$").test(control.value) ? null : { 'letters-only': true };
};

export const alphaNumericOnly = (control: AbstractControl<string>) => {
    return RegExp('^[a-zA-Z0-9 ]+$').test(control.value)
        ? null
        : { 'alphanumeric-only': true };
};
